import React, {Component} from 'react';
import ReactDOM from 'react-dom';

class Portal extends Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
		this.el.className = this.props.className;

		this.stopProp = e => e.stopPropagation();
	}

	componentDidMount() {
		document.body.appendChild(this.el);
		this.el.addEventListener('click', this.stopProp);
	}

	componentWillUnmount() {
		document.body.removeChild(this.el);
		this.el.removeEventListener('click', this.stopProp);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.className !== this.props.className) {
			this.el.className = nextProps.className;
		}
	}

	render() {
		return ReactDOM.createPortal(this.props.children, this.el);
	}
}

export default Portal;



// WEBPACK FOOTER //
// ./src/widgets/Portal.js